// app/actions/supabase-actions.ts
import { createClient } from "@/utils/supabase/client";
import { Database } from "@/types/supabase";
import { PostgrestError } from "@supabase/supabase-js";

export async function getMapData(): Promise<{
  data: Database['public']['Views']['exportmapdata']['Row'][] | null;
  error: PostgrestError | null;
}> {
  const supabase = createClient();
  const { data, error } = await supabase
    .from("exportmapdata")
    .select()
    .limit(110000);

  return { data, error };
}

export async function getMapClusterData(): Promise<{
  data: Database['public']['Views']['exportclusterdata']['Row'][] | null;
  error: PostgrestError | null;
}> {
  const supabase = createClient();
  const { data, error } = await supabase
    .from("exportclusterdata")
    .select(); 

  return { data, error };
}